angular.module('homebot.directives')

  .directive('videoRecorder', ['$timeout', 'HelperService', 'PageNotificationService', 'RollbarService', function($timeout, HelperService, PageNotificationService, RollbarService){
    return {
      controllerAs: 'recorderCtrl',
      bindToController: {
        bbApiKey: '=',
        home: '=',
      },
      restrict: 'E',
      scope: {},
      templateUrl: '/homes/templates/partials/video-recorder.html',
      controller: function(){
        var ctrl = this;
        var bbInstance;
        var video;

        ctrl.videoTitle = `Homebot - ${ctrl.home.address.street} - ${moment().format('M/D/YY')}`;
        ctrl.emailToAddress = _.map(ctrl.home.users, 'email').join(', ');
        ctrl.emailSubject = `A tip about your ${moment().format('MMMM')} Homebot report`
        ctrl.emailBodyContent = 'The market is changing rapidly. I\'ve outlined a few great opportunities for you here based on your current situation.'

        ctrl.launchVideoRecorder = function() {
          if (bbInstance) return;

          bbInstance = new BBCore({ accessToken: ctrl.bbApiKey });

          bbInstance.onError(function(errorInfo) {
            const errorMessage = errorInfo.message ? errorInfo.message : errorInfo;
            PageNotificationService.error(`An error occurred. Please contact us if this continues. ${errorMessage}`);
            RollbarService.error('BBCore Error:', errorInfo);
          });

          bbInstance.startVideoRecorder({ target: '#recorder', width: 360 }, function (videoInfo) {
            video = videoInfo;
            $timeout(function () {
              ctrl.toggleVideoSaveForm(true);
            }, 0);
          });
        };

        ctrl.saveVideo = function() {
          if (!ctrl.videoTitle) return;
          ctrl.saving = true;

          bbInstance.saveRecordedVideo(ctrl.videoTitle, video.videoId, video.filename, function (data) {
            ctrl.toggleVideoSaveForm();
            ctrl.saving = false;

            $timeout(ctrl.toggleEmailForm, 0);
          });
        };

        ctrl.sendVideoEmail = function() {
          ctrl.sending = true;

          const bodyContent = ctrl.emailBodyContent ? `${ctrl.emailBodyContent}<br /><br />` : '';

          const digestUrl = window.location.origin + window.location.pathname;
          const emailParams = {
            subject: ctrl.emailSubject,
            toAddresses: ctrl.emailToAddress.replace(/([\s,;,\,]+)/g, '; '),
            bodyContent: `${bodyContent}<a href="${digestUrl}">View your Homebot Report &rsaquo;&rsaquo;</a>`
          };

          bbInstance.videoQuickSend({
            subject: emailParams.subject,
            video_id: video.videoId,
            email_addresses: emailParams.toAddresses,
            mobile_message: emailParams.bodyContent
          }, function () {
            ctrl.sending = false;
            const emailAddresses = emailParams.toAddresses.replace(/([\s,;,\,]+)/g, ' & ');
            $timeout(ctrl.toggleEmailForm, 0);
            PageNotificationService.success(`Your video was sent to ${emailAddresses}!`);
          });
        };

        ctrl.toggleRecorder = function() {
          ctrl.showRecorder = !ctrl.showRecorder;
          if (ctrl.showRecorder) ctrl.launchVideoRecorder();
        };

        ctrl.toggleEmailForm = function() {
          ctrl.showEmailForm = !ctrl.showEmailForm;
        };

        ctrl.toggleVideoSaveForm = function(show) {
          if (_.isBoolean(show)) {
            ctrl.showVideoSaveForm = show;
            return;
          }

          ctrl.showVideoSaveForm = !ctrl.showVideoSaveForm;
        };
      }
    }
  }]);
